const getThemeSettings = (themeSettings, section) => {
  let content = {};
  let parsedData = themeSettings.asset.value;
  parsedData = JSON.parse(parsedData);
  const { sections } = parsedData?.current;
  content = sections && sections[section]?.settings;
  return content;
};

export default getThemeSettings;
